import { Layout } from "components2";
import {
    BackButton2, NextButton2, SeparatorLine, StepperBar
} from "components2/CommonUI";
import { APPT_TYPE } from "constants/o2Appointment";
import { useAdobeDigitalData } from "hooks";
import { useEffect } from "react";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateCrpsError, updateState } from "redux/o2Appointment";
import { O2APPOINTMENT_INFO, O2APPOINTMENT_REVIEW, O2CONTACT_DETAIL, O2FORM, O2IDENTITY } from "../constants/route";
import { SelectApptType, SelectCategory, SelectCompanion, SelectDateTimeRange, SelectLanguage, SelectLocation, SelectTimeslot } from "./o2ApointmentEntryComponents";
import { useWogaa } from "hooks";

// Back button can go to;
// 1. O2AppointmentInfo (if edit, have bookingTxnId)
// 2. O2ApointmentReview (creating, come back from review page, have apptTimeslotId)
// 3. O2Identity (if not login)
// 4. O2Form (if login)
// Back from O2ContactDetail will reset all the inputs
export default function O2AppointmentEntry() {
  const navigate = useNavigate();
  const { startComplete } = useWogaa();

  const { 
    idType, nricFin, passport, mid, sid, apptTypeId, language,
    haveCompanion, companionIdType, companionNricFin, companionPassport, 
    apptDateId, apptTimeRangeId, apptTimeslotId, locationId,
    apptType, isSlotAvailable,
    bookingTxnId, isCrps, isExperience, crpsError
  } = useSelector(
    (state) => state.o2Appointment
  );
  useAdobeDigitalData({name: "APPOINTMENT_ENTRY", path:"/appointment-entry"});

  const o2AppointmentState = useSelector(
    (state) => state.o2Appointment
  );

  const { isLogin } = useSelector((state) => state.signPassIdentify);
  // const [oldState, setOldState] = useState(null);
  const dispatch = useDispatch();

  const location = useLocation();
  const refSelectCompanion = useRef();

  const [hasLoaded, setHasLoaded] = useState(false);
  const [autoSelect, setAutoSelect] = useState(false);

  const [stepperItems, setStepperItems] = useState([
    { text: "Appointment details", current: true, complete: false },
    { text: "Contact details", current: false, complete: false },
    { text: "Review", current: false, complete: false }
  ]);

  useEffect(()=>{
    // back and next with valid one will cause not to reload the appt type.
    dispatch(updateCrpsError(null));
  }, []);

  // useEffect(()=>{
  //   if(bookingTxnId && oldState === null) {
  //     setOldState({...o2AppointmentState});
  //   }

  //   return(()=>{
  //     if(bookingTxnId && oldState !== null) {
  //       dispatch(updateState(oldState));
  //     }
  //   });
  // }, [oldState]);

  // Can come from identity page.
  // Can come from info page, to edit. 
  // Can come from form page if already login.
  const clkBack = () => {
    if(bookingTxnId) {
      // From info page. Go back without editing.
      navigate(O2APPOINTMENT_INFO);
      return;
    }
    // if(apptTimeslotId) {
    //   navigate(O2APPOINTMENT_REVIEW);
    //   return;
    // }
    if(!isLogin) {
      // no booking txnid, no login. 
      // Go back to identity page.
      navigate(O2IDENTITY);
      return;
    }
    // if (location.state?.from) {
    //   navigate(location.state.from);
    //   return;
    // }

    // There should not have any other case. 
    // But just go form page for default.
    navigate(O2FORM);
  };

  const clkNext = () => {
    // isNextDisabled event will cancel the click event, if it's supposed to be disabled
    // if(apptType === APPT_TYPE.VISIT && !refSelectCompanion.current.validate()) {
    //   console.log("companion not valid");
    //   return;
    // } 
    startComplete();
    navigate(O2CONTACT_DETAIL);
  };

  const isNextDisabled = () => {
    // if(!apptTypeId) {
    //   return true;
    // }
    // if(apptType === APPT_TYPE.VISIT) {
    //   if(!locationId) {
    //     return true;
    //   }
    //   if(haveCompanion && !companionIdType) {
    //     return true;
    //   }
    // }
    // return !apptDateId || !apptTimeslotId;
    if(!apptTimeslotId) {
      return true;
    }

    if(haveCompanion) {
      return !refSelectCompanion?.current?.isValid(haveCompanion, companionIdType);
    }

    return false;
  }

  // console.log("**##", apptTypeId, isSlotAvailable)
  
  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <StepperBar
          title={<span style={{ whiteSpace: "normal" }}>Book an appointment</span>}
          items={stepperItems}
        />
      }>
      <div>
        <div className="form-box--plain">
          <SelectCategory /*edit={location.state?.edit}*/ hasLoaded={hasLoaded} setHasLoaded={setHasLoaded} setAutoSelect={setAutoSelect} />
          <div className={`px-1 px-3 sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24 lg-mb-40 xl-mb-40`}>
          {sid !== null && !crpsError && (
            <>
              <SelectApptType /*edit={location.state?.edit}*/ hasLoaded={hasLoaded} setHasLoaded={setHasLoaded} autoSelect={autoSelect} setAutoSelect={setAutoSelect} />
              { apptType === APPT_TYPE.VISIT && isSlotAvailable && 
                  (!isCrps && !isExperience) && 
                  <SelectCompanion ref={refSelectCompanion} setAutoSelect={setAutoSelect} />}
                {apptTypeId !== null && isSlotAvailable && !isExperience && (
                  <SelectLanguage />
                )}
            </>
          )}
          </div>

          { apptTypeId !== null && isSlotAvailable && mid && sid && !crpsError && (
            <>
            <div className="row justify-content-center px-3 sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24">
              <SeparatorLine style={{ marginBottom: 0 }} />
            </div>
            <div className={"px-1 px-3 py-3 py-md-5 py-md-3"}>
              <h4 className={"mb-4 text-center"}>Select date and time</h4>
              <SelectLocation autoSelect={autoSelect} setAutoSelect={setAutoSelect} />
              <SelectDateTimeRange autoSelect={autoSelect} setAutoSelect={setAutoSelect} edit={location.state?.edit} /> 
              <SelectTimeslot autoSelect={autoSelect} setAutoSelect={setAutoSelect} />
            </div>
            </>
          )}

          <div className="form-footer">
            {/*<div className={"flex--space-between"}>*/}
            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <div className={"mobile-w-100"}>
                <BackButton2 onClick={clkBack} />
              </div>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <NextButton2 disabled={isNextDisabled()} onClick={clkNext} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
